import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";

export function TableSkeleton() {
  return (
    <Grid
      data-testid="tableSkeleton"
      container
      sx={{ justifyContent: "center", alignItems: "center" }}
    >
      <Grid size={11}>
        <Skeleton variant="text" height={60} />
        <Skeleton variant="text" height={60} />
        <Skeleton variant="text" height={60} />
        <Skeleton variant="text" height={60} />
        <Skeleton variant="text" height={60} />
        <Skeleton variant="text" height={60} />
        <Skeleton variant="text" height={60} />
      </Grid>
    </Grid>
  );
}

export function FormSkeleton() {
  return (
    <Grid container spacing={2} sx={{ alignItems: "center", p: "1em" }}>
      <Grid size={10}>
        <Skeleton variant="text" height={60} width={160} />
      </Grid>
      <Grid size={6}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid size={6}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid size={6}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid size={6}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid size={12}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid container sx={{ justifyContent: "center" }}>
        <Grid sx={{ mr: "1em", mb: "1em" }} size={3}>
          <Skeleton variant="text" height={60} />
        </Grid>
        <Grid size={3}>
          <Skeleton variant="text" height={60} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export function InvoiceDetailsSkeleton() {
  return (
    <Grid container columnSpacing={2} sx={{ alignItems: "center", p: "1em" }}>
      <Grid container rowSpacing={0}>
        <Grid
          sx={(theme) => ({
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            "& .MuiSkeleton-root": {
              height: 120,
            },
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column",
            },
          })}
          size={{ xs: 12, md: 6, lg: 7 }}
        >
          <Grid size={{ xs: 12, md: 1.5 }}>
            <Skeleton variant="text" />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Skeleton variant="text" />
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <Skeleton variant="text" />
          </Grid>
        </Grid>
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 4 }}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 4 }}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 4 }}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 4 }}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid size={12}>
        <Skeleton variant="text" height={60} width={120} />
      </Grid>
      <Grid size={12}>
        <Skeleton variant="text" height={7} />
      </Grid>
      <Grid container sx={{ justifyContent: "flex-end" }}>
        <Grid size={{ xs: 12, sm: 7, md: 7 }}>
          <Skeleton variant="text" height={60} />
        </Grid>
        <Grid size={{ xs: 12, sm: 7, md: 7 }}>
          <Skeleton variant="text" height={60} />
        </Grid>
        <Grid size={{ xs: 12, sm: 7, md: 7 }}>
          <Skeleton variant="text" height={60} />
        </Grid>
      </Grid>
      <Grid
        container
        sx={(theme) => ({
          justifyContent: "center",
          mb: "1rem",
          "& .MuiSkeleton-root:first-of-type": {
            mr: "1em",
            [theme.breakpoints.down("sm")]: {
              mr: 0,
            },
          },
        })}
      >
        <Grid size={{ xs: 12, sm: 1.5 }}>
          <Skeleton variant="text" height={60} />
        </Grid>
        <Grid size={{ xs: 12, sm: 1.5 }}>
          <Skeleton variant="text" height={60} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export function FormDetailsSkeleton() {
  return (
    <Grid container columnSpacing={2} sx={{ alignItems: "center", p: "1em" }}>
      <Grid container rowSpacing={0}>
        <Grid
          sx={(theme) => ({
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            "& .MuiSkeleton-root": {
              height: 120,
            },
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column",
            },
          })}
          size={{ xs: 12, md: 6, lg: 7 }}
        >
          <Grid size={{ xs: 12, sm: 1.5 }}>
            <Skeleton variant="text" />
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <Skeleton variant="text" />
          </Grid>
          <Grid size={{ xs: 12, sm: 5 }}>
            <Skeleton variant="text" />
          </Grid>
        </Grid>
      </Grid>
      <Grid container sx={{ margin: "0 0 1.25rem -0.75rem" }} columnSpacing={2}>
        <Grid size={2}>
          <Skeleton variant="text" height={60} />
        </Grid>
        <Grid size={2}>
          <Skeleton variant="text" height={60} />
        </Grid>
        <Grid size={2}>
          <Skeleton variant="text" height={60} />
        </Grid>
        <Grid size={2}>
          <Skeleton variant="text" height={60} />
        </Grid>
        <Grid size={2}>
          <Skeleton variant="text" height={60} />
        </Grid>
        <Grid size={2}>
          <Skeleton variant="text" height={60} />
        </Grid>
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 4 }}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 4 }}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 4 }}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 4 }}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 4 }}>
        <Skeleton variant="text" height={60} />
      </Grid>
      <Grid size={{ xs: 12, sm: 4, md: 4 }}>
        <Skeleton variant="text" height={60} />
      </Grid>
    </Grid>
  );
}

export function CardSkeleton() {
  return (
    <Grid
      container
      sx={{ justifyContent: "center", alignItems: "center", mt: "5rem" }}
    >
      <Grid size={{ xs: 11, sm: 10, md: 8 }}>
        <Grid
          container
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Grid
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            size={2.5}
          >
            <Skeleton variant="circular" width={60} height={60} />
          </Grid>
          <Grid size={9}>
            <Skeleton variant="text" height={80} />
            <Skeleton variant="text" height={80} />
          </Grid>
          <Grid container sx={{ justifyContent: "center" }}>
            <Skeleton variant="text" height={60} width={150} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export function RegisterFormSkeleton() {
  return (
    <Grid
      container
      spacing={0}
      sx={{
        justifyContent: "center",
        alignItems: "center",
        padding: "1rem",
      }}
    >
      <Grid size={{ xs: 12, sm: 7.5, md: 8.5 }}>
        <Grid container columnSpacing={2} rowSpacing={0}>
          <Grid size={12}>
            <Skeleton variant="text" height={70} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={70} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={70} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={70} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={70} />
          </Grid>
          <Grid size={12}>
            <Skeleton variant="text" height={70} />
          </Grid>
          <Grid size={12}>
            <Skeleton variant="text" height={70} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={70} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={70} />
          </Grid>
          <Grid
            container
            sx={(theme) => ({
              justifyContent: "center",
              m: "1rem 0",
              "& .MuiSkeleton-root:first-of-type": {
                mr: "1em",
                [theme.breakpoints.down("sm")]: {
                  mr: 0,
                },
              },
            })}
          >
            <Grid size={{ xs: 12, sm: 2.5 }}>
              <Skeleton variant="text" height={60} />
            </Grid>
            <Grid size={{ xs: 12, sm: 2.5 }}>
              <Skeleton variant="text" height={60} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export function NewAccountSkeleton() {
  return (
    <Grid
      container
      spacing={0}
      sx={{
        justifyContent: "center",
        alignItems: "center",
        padding: "1rem",
      }}
    >
      <Grid size={{ xs: 12, sm: 10 }}>
        <Grid container columnSpacing={3} rowSpacing={0}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={90} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={90} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={90} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={90} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={90} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={90} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={90} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant="text" height={90} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export function DigitalCardDialogSkeleton() {
  return (
    <Grid
      container
      rowSpacing={3}
      sx={{ justifyContent: "center", alignItems: "center" }}
    >
      <Grid size={{ xs: 11, sm: 8 }}>
        <Skeleton variant="text" height={85} />
      </Grid>
      <Grid size={{ xs: 11, sm: 7 }}>
        <Skeleton variant="text" height={140} />
      </Grid>
    </Grid>
  );
}

export function PreviewDialogSkeleton() {
  return (
    <Grid
      container
      sx={{
        justifyContent: "center",
        alignItems: "center",
        height: "90%",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Grid size={{ xs: 11, sm: 8 }}>
        <Skeleton
          variant="rectangular"
          height={550}
          sx={{ bgcolor: "grey.800" }}
        />
      </Grid>
    </Grid>
  );
}
